import { WebView } from '@zenbusiness/application-commons-webview';
import Box from '@zenbusiness/zui/Box';

import QRCodeInstruction from '#client/components/QRCodeInstruction';
import ScanToDownloadAppModal from '#client/components/ScanToDownloadAppModal';
import { MODAL_NAMES } from '#client/constants/modals';
import useModalContext from '#client/hooks/useModalContext';
import { checkIsMobile } from '#client/utils/devices';

export default function CheckDepositBanner() {
  const { isWebView } = WebView;
  const isDesktop = !checkIsMobile();
  const isShowBanner = isDesktop && !isWebView;
  const { openModal } = useModalContext();

  const onClick = () => {
    openModal({
      component: ScanToDownloadAppModal,
      name: MODAL_NAMES.SCAN_TO_DOWNLOAD_APP_MODAL
    });
  };

  if (isShowBanner) {
    return (
      <Box mt="30px">
        <QRCodeInstruction
          asImage
          hintText="Switch to your mobile browser or scan the QR code."
          onClick={onClick}
          questionText="Need to deposit a check?"
          url="/icon/misc/download_qr_code.png"
        />
      </Box>
    );
  }

  return null;
}
